var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7064 6.47517C13.0969 6.08465 13.0969 5.45148 12.7064 5.06096C12.3159 4.67044 11.6827 4.67044 11.2922 5.06096L5.10822 11.2449C4.89913 11.4282 4.76712 11.6973 4.76712 11.9972C4.76712 12.0012 4.76714 12.0052 4.76719 12.0091C4.76943 12.2621 4.86705 12.5143 5.06004 12.7073L11.2922 18.9395C11.6827 19.33 12.3159 19.33 12.7064 18.9395C13.0969 18.549 13.0969 17.9158 12.7064 17.5253L8.17833 12.9972H18.2329C18.7852 12.9972 19.2329 12.5495 19.2329 11.9972C19.2329 11.4449 18.7852 10.9972 18.2329 10.9972H8.1844L12.7064 6.47517Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowLeft.8724797e0c5c0f6b1facb42eb73cd014.svg";